import type { TMessages } from '@/types/TMessages'

export const messages = {
  action: 'Понятно',
} as const satisfies TMessages
